import { Injectable } from '@angular/core';

const SECTION_NAME = 'KH.SessionSettings';

@Injectable({
  providedIn: 'root'
})
export class SessionSettingsService {
  private sessionSettings: Record<string, any> | null = null;

  public get(setting: string): any {
    this.getSessionSettings();
    return this.sessionSettings![setting];
  };

  public set(setting: string, value: any): void {
    this.getSessionSettings();

    if (this.sessionSettings) {
      this.sessionSettings[setting] = value;
    }

    sessionStorage.setItem(SECTION_NAME, JSON.stringify(this.sessionSettings));
  };

  public clear(): void {
    this.sessionSettings = null;
    sessionStorage.removeItem(SECTION_NAME);
  };

  private getSessionSettings(): void {
    if (this.sessionSettings === null) {
      this.sessionSettings = JSON.parse(sessionStorage.getItem(SECTION_NAME) || '{}') || {};
    }
  }
}
